<template>
  <div class="page-footer">
    <div class="page-footer-img">
      <el-image :src="require('../assets/images/footbar.png')"></el-image>
    </div>
    <div class="footer-copyright w1200 w">
      <div class="company-info">
        <div class="icon-group">
          <a target="_blank"
             href="https://zzlz.gsxt.gov.cn/businessCheck/verifKey.do?showType=p&serial=9115090077946457X6-SAIC_SHOW_1000009115090077946457X61660032384235&signData=MEYCIQCB25+Lz3s0uAH/NhXqMvhKnFRFcDMB7EQvgwM3NWRaJAIhAKf5kifsRvRjnporqIY8hnLGGUyeg8nji2x0rYm1r1oL">
            <img width="60" height="60" src="../assets/img/lz4.png" alt="营业执照">
          </a>
          <a target="_blank"
             href="http://nmlz.saicjg.com/8043/authority?key=bbf70fe5779568386ac36016d236ac0f">
            <img width="60" height="60" src="../assets/img/siteBase.png" alt="营业执照">
          </a>
        </div>
        <div class="copyright">{{ informations.copyrightInformation }} {{informations.companyName}}版权所有</div>
        <div class="link-group">
          <a class="link" href="https://beian.miit.gov.cn/" target="_blank">{{ informations.icp }}</a>
          <a class="link" href="http://www.beian.gov.cn/portal/registerSystemInfo?spm=a21bo.21814703.1997523009.43.5af911d9dFYt6g&recordcode=46010002000773" target="_blank">琼公网安备46010002000773号</a>
          <a class="link" href="https://beian.miit.gov.cn/?spm=a21bo.21814703.1997523009.40.5af911d9dFYt6g#/Integrated/index" target="_blank">增值电信业务经营许可证：琼B2-20250514</a>
        </div>
<!--        <div class="link-group">-->
<!--          <a class="link" href="http://www.chinabarter.org/" target="_blank">中库会易货贸易网</a>-->
<!--          <a class="link" href="http://www.cgcc.org.cn/" target="_blank">中国商业联合会</a>-->
<!--        </div>-->
      </div>
      <div class="qrcode">
<!--        <div class="code-box">-->
<!--          <el-image class="img" :src="appImg"></el-image>-->
<!--          <div class="label">凤源电商APP</div>-->
<!--        </div>-->
        <div class="code-box">
          <el-image class="img" :src="mpImg"></el-image>
          <div class="label">腾信智慧电商小程序</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {copyRight} from '@/api/xunyou'

export default {
  name: "footernav",
  data() {
    return {
    };
  },
  computed:{
    mpImg () {
      return this.$store.state.staticPath + '/app/reg_wx.jpg'
    },
    appImg () {
      return this.$store.state.staticPath + '/app/dwd.png'
    },
    informations() {
      return this.$store.state.copyrights
    }
  },
  created() {
    this.geTCopyright();
  },
  methods: {
    // 获取版权名称
    geTCopyright() {
      copyRight().then(res => {
        console.log('版权', res);
        if (res.code === 0) {
          const copyInfo = res.rows.length ? res.rows[0] : ''
          this.$store.commit('SAVE_COPYRIGHTS', copyInfo)
        }
      }).catch(err => {
        this.$message.error('查询失败,请稍后再试!')
      })
    }
  }
};
</script>
<style scoped lang="less">
.page-footer{
  background-color: #fff;
  margin-top: 20px;
  .page-footer-img{
    text-align: center;
    padding: 20px 0;
    border-bottom: 3px solid var(--main-theme-color);
  }
  .footer-copyright{
    padding: 20px 0;
    line-height: 1.8;
    font-weight: 500;
    white-space: nowrap;
  }
  .company-info{
    display: inline-block;
    width: 700px;
    vertical-align: top;
  }
  .icon-group{
    padding: 10px 0;
  }
  .copyright{
    color: #888888;
  }
  .link-group{
    .link{
      cursor: pointer;
      color: #888888;
      &:hover{
        color: var(--main-theme-color);
        text-decoration: underline;
      }
      &:last-child:after{
        display: none;
      }
      &:after{
        content: '';
        display: inline-block;
        height: 10px;
        width: 1px;
        margin: 0 10px;
        background-color: #cccccc;
      }
    }
  }
  .qrcode{
    display: inline-block;
    width: 500px;
    vertical-align: top;
    text-align: right;
    .code-box{
      display: inline-block;
      text-align: center;
      color: #888888;
      margin-left: 50px;
      .img{
        width: 120px;
        height: 120px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footernav.vue